import BannerCounter from '@components/BannerCounter';
import Image from '@components/Image';
import Indicator from '@components/Indicator';
import useOnBannerClick from '@hooks/banner/useOnBannerClick';
import {
  Fragment, useEffect, useRef, useState,
} from 'react';
import Slider from 'react-slick';

import useMainBanners from './hooks/useMainBanners';
import usePreventClickOnDrag from './hooks/usePreventClickOnDrag';
import styles from './styles.module.scss';

function MainBanners() {
  const [index, setIndex] = useState<number>(0);
  const banners = useMainBanners();
  const { beforeChange, afterChange, onDragItemClick } = usePreventClickOnDrag();
  const sliderRef = useRef<Slider>(null);
  const onBannerClick = useOnBannerClick();
  useEffect(() => {
    const interval = setInterval(() => {
      sliderRef.current?.slickNext();
    }, 2500);
    return () => clearInterval(interval);
  }, [sliderRef]);

  if (banners && banners.length !== 0) {
    return (
        <div className={styles.container}>
            {banners.length > 1 ? (
                <Fragment>
                    <Slider dots={false}
                            ref={sliderRef}
                            className={styles.slider}
                            beforeChange={beforeChange}
                            afterChange={(newIndex) => {
                              setIndex(newIndex);
                              afterChange();
                            }}>
                        {banners?.map((banner, i) => (
                            <div key={`banner ${i}`}
                                 onClick={() => {
                                   onDragItemClick(() => onBannerClick(banner));
                                 }}
                                 className={styles.imageWrapper} >
                                <Image alt='배너'
                                       width={400}
                                       height={400}
                                       className={styles.image}
                                       src={banner.imageUrl} />
                            </div>
                        ))}
                    </Slider>
                    <BannerCounter totalCount={banners.length}
                                   right={20}
                                   bottom={22}
                                   index={index} />
                </Fragment>
            ) : (
                <div
                     onClick={() => onBannerClick(banners[0])}
                     className={styles.imageWrapper} >
                    <Image alt='배너'
                           width={400}
                           height={400}
                           className={styles.image}
                           src={banners[0].imageUrl} />
                </div>
            )}
        </div>
    );
  }
  return (<Fragment/>);
}

export default MainBanners;
